export default __webpack_public_path__ + "static/banner-hero-f15c53c763d4b84d242deb2626da994f.jpg";